// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__wXKC_","disabled":"FileBtn_disabled__3VlU9","warn":"FileBtn_warn__3Nmqs","fade":"FileBtn_fade__TopNv"};